import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import { emailPinRequest } from '../services';

export const useSendEmailPin = ({ onSuccess }: { onSuccess?: () => void }) => {
  return useMutation<void, AxiosError, { email: string }>({
    mutationFn: emailPinRequest,
    onSuccess,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      const message = error?.response?.data?.payload?.message;
      let errorText = message || 'Something went wrong...';

      if (message === 'account/email-not-exists') {
        errorText = 'Email does not exist.';
      }

      throw new Error(errorText);
    },
  });
};
